import React from 'react';
import styles from '../styles.module.scss';

const Title = () => {
    return (
        <div className={styles['title__container']}>
            <h3 className={styles['title']}>航班詳情</h3>
            <span className={styles['title__sub-title']}>
                航班時間僅為參考，最終確定之使用航班，以說明會資料為準
            </span>
        </div>
    );
};

export default Title;
